module.exports = __webpack_public_path__ + "static/album-e9c296499f569eee2d058244db809f19.png";